import { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { Loader2, Key, Eye, EyeOff } from "lucide-react";

export function ChangePasswordCard({ authAxios }) {
  const [pwCurrent, setPwCurrent] = useState("");
  const [pwNew, setPwNew] = useState("");
  const [pwConfirm, setPwConfirm] = useState("");
  const [pwLoading, setPwLoading] = useState(false);
  const [showPwCurrent, setShowPwCurrent] = useState(false);
  const [showPwNew, setShowPwNew] = useState(false);

  const handleChangePassword = async () => {
    if (!pwCurrent) { toast.error("Informe a senha atual"); return; }
    if (pwNew.length < 8) { toast.error("Nova senha deve ter ao menos 8 caracteres"); return; }
    if (pwNew !== pwConfirm) { toast.error("Senhas nao coincidem"); return; }
    setPwLoading(true);
    try {
      await authAxios.put("/auth/change-password", { current_password: pwCurrent, new_password: pwNew });
      toast.success("Senha alterada! Faca login novamente.");
      setPwCurrent(""); setPwNew(""); setPwConfirm("");
      setTimeout(() => { window.location.href = "/login"; }, 1500);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro ao alterar senha");
    }
    setPwLoading(false);
  };

  return (
    <Card data-testid="change-password-card">
      <CardHeader>
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-orange-50 flex items-center justify-center">
            <Key className="w-5 h-5 text-orange-600" />
          </div>
          <div className="flex-1">
            <CardTitle className="text-base">Alterar Senha</CardTitle>
            <CardDescription>Atualize a senha da sua conta</CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div>
          <Label className="text-xs text-gray-500 mb-1.5 block">Senha atual</Label>
          <div className="relative">
            <Input
              type={showPwCurrent ? "text" : "password"}
              value={pwCurrent}
              onChange={e => setPwCurrent(e.target.value)}
              placeholder="••••••••"
              className="pr-10"
              data-testid="pw-current-input"
            />
            <button type="button" className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600" onClick={() => setShowPwCurrent(v => !v)}>
              {showPwCurrent ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            </button>
          </div>
        </div>
        <div>
          <Label className="text-xs text-gray-500 mb-1.5 block">Nova senha</Label>
          <div className="relative">
            <Input
              type={showPwNew ? "text" : "password"}
              value={pwNew}
              onChange={e => setPwNew(e.target.value)}
              placeholder="Minimo 8 caracteres"
              className="pr-10"
              data-testid="pw-new-input"
            />
            <button type="button" className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600" onClick={() => setShowPwNew(v => !v)}>
              {showPwNew ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
            </button>
          </div>
        </div>
        <div>
          <Label className="text-xs text-gray-500 mb-1.5 block">Confirmar nova senha</Label>
          <Input
            type="password"
            value={pwConfirm}
            onChange={e => setPwConfirm(e.target.value)}
            placeholder="Repita a nova senha"
            data-testid="pw-confirm-input"
            onKeyDown={e => e.key === "Enter" && handleChangePassword()}
          />
          {pwConfirm && pwNew !== pwConfirm && (
            <p className="text-xs text-red-500 mt-1">Senhas nao coincidem</p>
          )}
        </div>
        <Button
          onClick={handleChangePassword}
          disabled={pwLoading || !pwCurrent || !pwNew || !pwConfirm}
          className="bg-orange-600 hover:bg-orange-700 text-white gap-2 w-full"
          data-testid="change-password-btn"
        >
          {pwLoading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Key className="w-4 h-4" />}
          Alterar Senha
        </Button>
      </CardContent>
    </Card>
  );
}
